import { render, staticRenderFns } from "./QuickAddAppointment.vue?vue&type=template&id=0622ea76&"
import script from "./QuickAddAppointment.vue?vue&type=script&lang=ts&"
export * from "./QuickAddAppointment.vue?vue&type=script&lang=ts&"
import style0 from "./QuickAddAppointment.vue?vue&type=style&index=0&id=0622ea76&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports